module.exports = __webpack_public_path__ + "static/media/SCST.3e24b704.svg";